module.exports = __webpack_public_path__ + "img/ce0d2a6.png";